export default {
    data() {
        return {
            plazasConf: {},
            plazasSeleccionadas: [],
            butacasSeleccionadas: []
        }
    },
    watch: {
        butacasSeleccionadas() {
            this.plazasSeleccionadas = this.butacasSeleccionadas;
        }
    },
    computed: {
        confValida() {
            if (this.plazasSeleccionadas.every(plaza => !plaza.sector)) {
                return true;
            }

            if (this.event && !this.event.comprobacion_butacas) {
                return true;
            }

            if (!this.checkSectorFila()) {
                return false;
            }

            if (this.plazasSeleccionadas.length > 0) {
                const firstPlaza = this.plazasSeleccionadas[0];
                const lastPlaza = this.plazasSeleccionadas[this.plazasSeleccionadas.length - 1];
                const firstIndex = this.plazasConf[firstPlaza.sector][firstPlaza.fila].findIndex(plazaSearch => plazaSearch.id === firstPlaza.id);
                const lastIndex = this.plazasConf[lastPlaza.sector][lastPlaza.fila].findIndex(plazaSearch => plazaSearch.id === lastPlaza.id);
    
                for (const plaza of this.plazasSeleccionadas) {
                    const index = this.plazasConf[plaza.sector][plaza.fila].findIndex(plazaSearch => plazaSearch.id === plaza.id);
    
                    if (index >= 0) {
                        if (lastIndex === this.plazasConf[plaza.sector][plaza.fila].length - 1) {
                            if (!this.checkButacaSiguiente(plaza, index)) {
                                return false;
                            }
                        } else if (firstIndex === 0) {
                            if (!this.checkButacaAnterior(plaza, index)) {
                                return false;
                            }
                        } else {
                            if (!this.checkButacaSiguiente(plaza, index) || !this.checkButacaAnterior(plaza, index)) {
                                return false;
                            }
                        }
                    } else {
                        return false;
                    }
                }
    
                return true;                
            }

            return true;
        },
    },
    methods: {
        setPlazasConf(plazas) {
            this.plazasConf = {};

            plazas.forEach(plaza => {
                if (!this.plazasConf[plaza.sector]) {
                    this.plazasConf[plaza.sector] = {};
                }

                if (!this.plazasConf[plaza.sector][plaza.fila]) {
                    this.plazasConf[plaza.sector][plaza.fila] = [];
                }

                const fila = this.plazasConf[plaza.sector][plaza.fila];
                fila.push(plaza);
                if (this.configuracion?.hash_teatro === '6fG13COAYaetOZ1jZWTg') {
                    fila.sort((a, b) => {
                        const aEven = a.butaca % 2 === 0;
                        const bEven = b.butaca % 2 === 0;

                        if (aEven && !bEven) {
                            return -1;
                        } else if (!aEven && bEven) {
                            return 1;
                        } else {
                            return a.butaca - b.butaca;
                        }
                    });
                } else {
                    fila.sort((a, b) => a.butaca - b.butaca);
                }
            });
        },
        checkButacaSiguiente(butaca, index) {
            if (!butaca.pasillo_izquierda) {
                const siguienteButaca = this.plazasConf[butaca.sector][butaca.fila][index + 1];
                const siguienteButaca2 = this.plazasConf[butaca.sector][butaca.fila][index + 2];
                    
                if (!siguienteButaca) return true;
    
                const butacaEncontrada = this.plazasSeleccionadas.some(plaza => plaza.id === siguienteButaca.id);
                    
                if (!butacaEncontrada) {
                    if (siguienteButaca.pasillo_izquierda) return false;
                    if (siguienteButaca2) {
                        const butacaEncontrada2 = this.plazasSeleccionadas.some(plaza => plaza.id === siguienteButaca2.id);
                    
                        if (siguienteButaca.disponible && (butacaEncontrada2 || !siguienteButaca2.disponible)) {
                            return false;
                        }
                    
                        return !butacaEncontrada2;
                    }
                    return false;
                }
            }

            return true;
        },
        checkButacaAnterior(butaca, index) {
            if (!butaca.pasillo_derecha) {
                const anteriorButaca = this.plazasConf[butaca.sector][butaca.fila][index - 1];
                const anteriorButaca2 = this.plazasConf[butaca.sector][butaca.fila][index - 2];
    
                if (!anteriorButaca) return true;
        
                const butacaEncontrada = this.plazasSeleccionadas.some(plaza => plaza.id === anteriorButaca.id);
    
                if (!butacaEncontrada) {
                    if (anteriorButaca.pasillo_derecha) return false;
                    if (anteriorButaca2) {
                        const butacaEncontrada2 = this.plazasSeleccionadas.some(plaza => plaza.id === anteriorButaca2.id);
    
                        if (anteriorButaca.disponible && (butacaEncontrada2 || !anteriorButaca2.disponible)) {
                            return false;
                        }
    
                        return !butacaEncontrada2;
                    }
                    return false;
                }
            }

            return true;
        },
        checkSectorFila() {
            return this.plazasSeleccionadas.every(plaza => {
                return (plaza.sector === this.plazasSeleccionadas[0].sector) &&
                (plaza.fila === this.plazasSeleccionadas[0].fila)
            })
        },
    }
}